/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PaymentOptions } from './PaymentOptions';
const AccessRevokedParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('access-revoked')],
    ['paymentOptions', PaymentOptions, 'payment_options'],
]);
export class AccessRevoked extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AccessRevokedParser.decode(input).map(res => new AccessRevoked(res));
    }
    static unsafeDecode(input) {
        return AccessRevoked.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessRevokedParser.encode(data);
    }
    static schema() {
        return AccessRevokedParser.schema();
    }
}
